export enum ExerciseSection {
  INDIVIDUAL = 'individual',
}
